import { Injectable } from '@angular/core';
import { loadInitializerData } from '../core/state/core.actions';
import { Store } from '@ngrx/store';
import { first } from 'rxjs';
import { selectAppFeatures } from '../core/state/core.selectors';

@Injectable({
    providedIn: 'root'
})
export class AppInitializerService {
    constructor(private store: Store) {}

    init(): Promise<void> {
        return new Promise(resolve => {
            this.store.dispatch(loadInitializerData({ currentUrl: window.location.href }));
            this.store
                .select(selectAppFeatures)
                .pipe(first())
                .subscribe(features => {
                    if (features != null) {
                        resolve();
                    }
                });
        });
    }
}
